import React from 'react';
import {
	SelectBoxField,
	PasswordField,
	TextField,
	DateTimeField,
	FileField,
	FilesField,
	CheckBoxField,
	MaskField,
	HelpBlock,
	TextAreaField,
	Customer,
	NumberBox,
	Participant,
	RadioField,
	RelationField,
} from './Fields';
import { RenderField } from './UniversalForm';
import type { Select2WebElementModel } from 'src/Controls/RelationSelectBox/API';

export interface RelationFieldType {
	method?: 'post' | 'get';
	url: string;
	valueKey: string;
	titleKey?: string;
	filterable?: boolean;
	serverSideSearch?: boolean;
	enablePagination?: boolean;
	onPrepareRequestData?: (params?: any) => any;
	onPrepareResponseData?: (
		options: Select2WebElementModel[],
	) => Select2WebElementModel[];
}

enum FieldTypes {
	text = 'text',
	textArea = 'textArea',
	dateTime = 'dateTime',
	number = 'number',
	checkBox = 'checkBox',
	select = 'select',
	radio = 'radio',
	file = 'file',
	files = 'files',
	masked = 'masked',
	help = 'helpBlock',
	password = 'password',
	relation = 'relation',
	participant = 'participant',
	customer = 'customer',
}

export interface IOptions {
	value: any;
	display: string;
	disable?: boolean;
}

interface IBaseField {
	name: string;
	type: FieldTypes | string;
	title?: string;
	defaultValue?: any;
	isFullRow?: boolean;
	isRequired?: boolean;
	readOnly?: boolean;
	disabled?: boolean;
}

export interface IField extends IBaseField {
	options?: IOptions[];
	regex?: RegExp | string;
	placeholder?: string;
	visible?: boolean;
	relation?: RelationFieldType;
	withTime?: boolean;
	needParse?: boolean;
	accept?: string;
	multiple?: boolean;
	mask?: string | RegExp | Array<string | RegExp>;
	formatChars?: Record<string, string>;
	autoUpperCase?: boolean;
	body?: React.ReactNode;
	maskChar?: string;
	col?: boolean;
	setData?: (newValue: any) => void;
	onChangeValue?: (newValue: any) => void;
	inline?: boolean;
	rows?: number;
	/** Максимальное количество символов в текстовом поле */
	maxLength?: number;
	/** Исключать из списка выбора текущего заявителя */
	excludeCurrentCustomer?: boolean;
	/** Подстраивать высоту инпута автоматически */
	isAutoHeight?: boolean;

	/** Минимальная дата, доступная для выбора */
	minDate?: Date;
	/** Максимальная дата, доступная для выбора */
	maxDate?: Date | 'today';
	allowScan?: boolean;
	allowAdd?: boolean;
	autoFocus?: boolean;
	id?: string;
}

export interface IFieldProps {
	name: string;
	title: string;
	placeholder?: string;
	setData: Function;
	errors: any;
	touched: any;
	isRequired: boolean;
	disabled: boolean;
	options: IOptions[];
	onChangeValue: (value: any) => void;
}

export interface ISection {
	title?: string;
	fields: IField[];
	isFull: boolean;
}

export const FieldsComponent: any = {
	text: TextField,
	select: SelectBoxField,
	radio: RadioField,
	checkBox: CheckBoxField,
	dateTime: DateTimeField,
	file: FileField,
	files: FilesField,
	masked: MaskField,
	helpBlock: HelpBlock,
	textArea: TextAreaField,
	password: PasswordField,
	relation: RelationField,
	customer: Customer,
	participant: Participant,
	number: NumberBox,
};

/**  */
export const getValue = (obj: any, key: string): string => {
	if (!obj) {
		return '';
	}
	if (key.indexOf('.') !== -1) {
		const keys = key.split('.');
		let o = obj;
		for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			o = o[k];
			if (!o) {
				return '';
			}
		}
		return o;
	}
	return obj[key];
};

export type UniversalFormRefType = {
	setErrorField: (fieldName: string, errorMsg?: string) => void;
};

export { RenderField };
export { default as FieldGroup } from './FieldGroup';
export { default as UniversalForm } from './UniversalForm';
export { default as HelperBlock } from './Fields/HelpBlock/HelperBlock';
